import { useState } from 'react';

import { MenuItem } from '@mui/material';
import { useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { useMutationDeleteRiskRegister } from 'api/mutations/deleteRiskRegister.mutate';

import Icon from 'components/common/Icons/base/Icon/Icon';

import { CustomizedConfirmDeleteModal, CustomizedDropdownMenu, CustomizedRoundIcon } from 'components/common';
import classes from 'components/widgets/ActivityCompletionPlan/components/RowOptionsCell/RowOptionsCell.module.scss';

interface Props {
    riskId: number;
    name: string;
}

export const RowOptionsCell = ({ riskId, name }: Props) => {
    const [show, setShow] = useState<boolean>(false);
    const mutation = useMutationDeleteRiskRegister();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();
    const { pathname } = useLocation();
    const history = useHistory();
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleDeleteRisk = () => {
        sendEventWithDimensions({ action: 'Delete Single Risk', label: name, category: 'Risk Register' });
        mutation.mutate(
            { riskId: [riskId] },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries('getRiskRegister').then(() => {
                        handleSnackBar(`Risk deleted successfully`, 'success');
                    });
                },
                onError: (error) => DEFAULT_ERROR({ error, handleError: handleSnackBar }),
            },
        );
        setShow(false);
    };

    const handleEdit = () => {
        history.push(`${pathname}/update-${riskId}`);
    };

    return (
        <div className={`${classes.rowOptionsCell}`}>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedRoundIcon
                        size={'30px'}
                        backGroundColor={'transparent'}
                        isBorder={false}
                        hoverColor={'none'}
                        enableHover={false}
                    >
                        <Icon name={'three-dot-icon'} />
                    </CustomizedRoundIcon>
                }
            >
                <MenuItem onClick={() => handleEdit()}>Edit</MenuItem>
                <MenuItem onClick={() => setShow(true)}>Delete</MenuItem>
            </CustomizedDropdownMenu>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete risk register ${name}?`}
                onConfirm={handleDeleteRisk}
            />
        </div>
    );
};
